import axiosInstance from '../api';
import {
  ChildCommentLikeRequest,
  ChildCommentLikeResponse,
  ChildCommentUnlikeResponse,
  ChildCommentLikesCountResponse,
  ChildCommentLikersResponse,
  ChildCommentLikeStatusResponse
} from './childCommentLikeApi.types';

/**
 * 子コメントに「いいね」する
 * @param child_comment_id - 子コメントID
 * @returns いいね作成結果
 */
export const likeChildComment = async (
  child_comment_id: number | string
): Promise<ChildCommentLikeResponse> => {
  const response = await axiosInstance.post<ChildCommentLikeResponse>(
    '/child-comment-likes',
    { child_comment_id },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  return response.data;
};

/**
 * 子コメントの「いいね」を取り消す
 * @param child_comment_id - 子コメントID
 * @returns 取り消し結果
 */
export const unlikeChildComment = async (
  child_comment_id: number | string
): Promise<ChildCommentUnlikeResponse> => {
  const response = await axiosInstance.delete<ChildCommentUnlikeResponse>('/child-comment-likes', {
    params: { child_comment_id }
  });
  return response.data;
};

/**
 * 子コメントの「いいね」数を取得する
 * @param child_comment_id - 子コメントID
 * @returns いいね数
 */
export const getChildCommentLikesCount = async (
  child_comment_id: number | string
): Promise<ChildCommentLikesCountResponse> => {
  console.log(`getChildCommentLikesCount呼び出し: ID=${child_comment_id}, 型=${typeof child_comment_id}`);
  
  // IDを確実に文字列に変換
  const stringId = String(child_comment_id);
  
  const response = await axiosInstance.get<ChildCommentLikesCountResponse>('/child-comment-likes/count', {
    params: { child_comment_id: stringId }
  });
  
  console.log(`getChildCommentLikesCount APIレスポンス:`, response.data);
  return response.data;
};

/**
 * 子コメントを「いいね」したユーザー一覧を取得する
 * @param child_comment_id - 子コメントID
 * @returns いいねしたユーザー一覧
 */
export const getChildCommentLikers = async (
  child_comment_id: number | string
): Promise<ChildCommentLikersResponse> => {
  const response = await axiosInstance.get<ChildCommentLikersResponse>('/child-comment-likes/likers', {
    params: { child_comment_id }
  });
  
  // idを常に文字列にするための変換を追加
  const transformedData: ChildCommentLikersResponse = {
    ...response.data,
    likers: response.data.likers.map(liker => ({
      ...liker,
      id: String(liker.id)
    }))
  };
  
  return transformedData;
};

/**
 * 現在のユーザーの子コメントいいね状態を取得する
 * @param child_comment_id - 子コメントID
 * @returns いいね状態
 */
export const getChildCommentLikeStatus = async (
  child_comment_id: number | string
): Promise<ChildCommentLikeStatusResponse> => {
  const response = await axiosInstance.get<ChildCommentLikeStatusResponse>('/child-comment-likes/status', {
    params: { child_comment_id }
  });
  return response.data;
}; 